import { MdLightbulbOutline, MdSchool, MdBusiness } from 'react-icons/md';
import { RiMicroscopeFill } from 'react-icons/ri';
import { BiDna } from 'react-icons/bi';
import { IoFlask } from 'react-icons/io5';
import { GrDocumentText } from 'react-icons/gr';
import {
  AcademicCapIcon,
  BeakerIcon,
  BuildingLibraryIcon,
  BuildingOfficeIcon,
  DocumentIcon,
  LightBulbIcon,
  PresentationChartLineIcon,
  QrCodeIcon,
} from '@heroicons/react/24/solid';

const commonSubmissionFormFields = ['title', 'details', 'files'] as const;

export const ENV = {
  SERVER_API_HOST: process.env.SERVER_API_HOST,

  // Public (available to client) env vars
  NEXT_PUBLIC_DEBUG: process.env.NEXT_PUBLIC_DEBUG || '',
  NEXT_PUBLIC_CLIENT_API_HOST: process.env.NEXT_PUBLIC_CLIENT_API_HOST,
  NEXT_PUBLIC_GA_TRACKING_ID: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
  NEXT_PUBLIC_GA_4_TRACKING_ID: process.env.NEXT_PUBLIC_GA_4_TRACKING_ID,
  NEXT_PUBLIC_CAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || '6LdWTLgqAAAAAA3IOSWr1mTAj8jukPL2ouSjoXYJ',
  NEXT_PUBLIC_COMPANIES_APP_URL: process.env.NEXT_PUBLIC_COMPANIES_APP_URL || 'http://localhost:3000',
  NEXT_PUBLIC_UNIVERSITY_DASHBOARD_URL:
    process.env.NEXT_PUBLIC_UNIVERSITY_DASHBOARD_URL || 'http://localhost:3000/university-dashboard',
  NEXT_PUBLIC_S3_BUCKET_URL_ASSETS: process.env.NEXT_PUBLIC_S3_BUCKET_URL_ASSETS,
  NEXT_PUBLIC_ORGANISATION_NAME: 'Inpart',
} as const;

export const OPPORTUNITY_TYPES = {
  academic: {
    label: 'Academic Profiles',
    labelSingular: 'Academic Profile',
    Icon: MdSchool,
    IconNew: AcademicCapIcon,
    discover: {
      id: 2,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: commonSubmissionFormFields,
    },
  },

  biotechAsset: {
    label: 'Biopharma Assets',
    labelSingular: 'Biopharma Asset',
    Icon: BiDna,
    IconNew: BeakerIcon,
    discover: {
      id: 6,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: [
        ...commonSubmissionFormFields,
        'patents',
        'ipStatus',
        'seeking',
        'assetType',
        'underlyingTechnology',
        'therapeuticAreas',
        'mechanismOfAction',
        'target',
        'developmentStages',
      ],
    },
    opportunityForm: {
      fields: [
        'title',
        'headerImage',
        'details',
        'patents',
        'ipStatus',
        'seeking',
        'assetType',
        'underlyingTechnology',
        'therapeuticAreas',
        'mechanismOfAction',
        'target',
        'developmentStages',
      ],
    },
  },

  centreOfExcellence: {
    label: 'Centres of Excellence',
    labelSingular: 'Centre of Excellence',
    Icon: RiMicroscopeFill,
    IconNew: BuildingLibraryIcon,
    discover: {
      id: 3,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: commonSubmissionFormFields,
    },
  },

  platformTechnology: {
    label: 'Technologies',
    labelSingular: 'Technology',
    Icon: MdLightbulbOutline,
    IconNew: QrCodeIcon,
    discover: {
      id: 'platformTechnology',
      availability: ['university-admin'],
    },
    submissionForm: {
      fields: [],
    },
  },

  researchProject: {
    label: 'Research Projects',
    labelSingular: 'Research Project',
    Icon: IoFlask,
    IconNew: PresentationChartLineIcon,
    discover: {
      id: 4,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: commonSubmissionFormFields,
    },
  },

  spinout: {
    label: 'Company Profiles',
    labelSingular: 'Company Profile',
    Icon: MdBusiness,
    IconNew: BuildingOfficeIcon,
    discover: {
      id: 5,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: commonSubmissionFormFields,
    },
  },

  technology: {
    label: 'Technologies',
    labelSingular: 'Technology',
    Icon: MdLightbulbOutline,
    IconNew: LightBulbIcon,
    discover: {
      id: 1,
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: commonSubmissionFormFields,
    },
  },

  rfpApplication: {
    label: 'Request for Proposals',
    labelSingular: 'Request for Proposal',
    Icon: GrDocumentText,
    IconNew: DocumentIcon,
    discover: {
      id: 'rfpApplication',
      availability: ['university-admin', 'university', 'academic'],
    },
    submissionForm: {
      fields: [
        {
          name: 'files',
          label: 'Upload submission form',
          description:
            'Once you have downloaded and completed your submission form, please click the “add” below to upload it.',
        },
      ],
    },
  },
} as const;
